import type { ReactNode } from 'react';

interface QuotationHeroProps {
  title: ReactNode;
  subtitle?: ReactNode;
  right?: ReactNode;
}

/**
 * Shared gradient hero used at the top of every quotation page.
 * Standardizes brand→indigo gradient, glow, and animation across List,
 * Detail, and Analytics views.
 */
export function QuotationHero({ title, subtitle, right }: QuotationHeroProps) {
  return (
    <div className="relative overflow-hidden bg-gradient-to-r from-brand-600 to-indigo-600 rounded-2xl p-6 text-white shadow-[0_20px_60px_-20px_rgba(37,99,235,0.45)] mb-6 animate-fade-in">
      <div className="pointer-events-none absolute -top-24 -right-24 h-56 w-56 rounded-full bg-white/20 blur-3xl" />
      <div className="pointer-events-none absolute -bottom-20 -left-10 h-48 w-48 rounded-full bg-black/10 blur-3xl" />
      <div className="relative flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
        <div className="min-w-0">
          <div className="text-2xl font-bold tracking-tight">{title}</div>
          {subtitle && <div className="text-sm text-brand-100 mt-1">{subtitle}</div>}
        </div>
        {right && <div className="shrink-0">{right}</div>}
      </div>
    </div>
  );
}
